import { handleActions } from 'redux-actions';
import {
  FETCH_CATEGORIES_PENDING,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_ERROR,
} from '../actions/categories';


const defaultState = { data: localStorage.getItem('categories') ? JSON.parse(localStorage.getItem('categories')) : [],  loading: false };

export default handleActions({
  [FETCH_CATEGORIES_PENDING]: (state, action) => {
    return {
      data: undefined,
      loading: true,
      cancelTokenSource: action.payload.cancelTokenSource
    };
  },
  [FETCH_CATEGORIES_SUCCESS]: (state, action) => {
    return {
      data: action.payload,
      loading: false,
      cancelTokenSource: null
    };
  },
  [FETCH_CATEGORIES_ERROR]: (state, action) => {
    return {
      data: undefined,
      loading: false,
      error: action.payload,
      cancelTokenSource: null
    };
  }
}, defaultState)